import { takeLatest } from 'redux-saga/effects'
import {
  createFulfillmentOperator,
  getFulfillmentOperators,
  updateFulfillmentOperatorStatus,
} from 'redux/slices/fulfillmentOperatorSlice'
import {
  handleCreateFulfillmentOperator,
  handleGetFulfillmentOperators,
  handleUpdateFulfillmentOperatorStatus,
} from '../handlers/fulfillmentOperatorHandler'

const fulfillmentOperatorSaga = [
  takeLatest(getFulfillmentOperators.type, handleGetFulfillmentOperators),
  takeLatest(createFulfillmentOperator.type, handleCreateFulfillmentOperator),
  takeLatest(
    updateFulfillmentOperatorStatus.type,
    handleUpdateFulfillmentOperatorStatus,
  ),
]

export default fulfillmentOperatorSaga
